import findex from 'app/assets/icons/findex.png'
import milkChocolate from 'app/assets/icons/milk-chocolate.png'
import moove from 'app/assets/icons/moove.webp'
import { Box } from 'app/components/design-system-components'
import InvestDashboardTile from 'app/sm/renter_investment_dashboard/invest_dashboard_tile'
import {
  GTM_FINDEX_DASHBOARD_LINK,
  GTM_MILK_CHOCOLATE_DASHBOARD_CTA_BUTTON,
  GTM_MOOVE_DASHBOARD_LINK,
} from 'app/utils/google-tag-manager/helpers'

const investDashboardTileProps = [
  {
    text: 'Buyers Agency',
    textStrong: 'Your property purchase companion.',
    textDesc: (
      <>
        Unlock your <strong>exclusive savings</strong> here!
      </>
    ),
    onClick: () =>
      window.open(
        ' https://get.snug.com/rentvest/milkchocolate/#lp-pom-box-105',
        '_blank',
      ),
    image: milkChocolate,
    buttonText: 'Find out more',
    buttonGTMClassName: GTM_MILK_CHOCOLATE_DASHBOARD_CTA_BUTTON,
    buttonDisabled: false,
  },
  {
    text: 'Buyers Agency',
    textStrong: 'Find your favourite Investment Property.',
    textDesc: (
      <>
        Discover your <strong>special offer!</strong>
      </>
    ),
    onClick: () =>
      window.open(
        'https://get.snug.com/rentvest/moove/#lp-pom-box-105',
        '_blank',
      ),
    image: moove,
    buttonText: 'Find out more',
    buttonGTMClassName: GTM_MOOVE_DASHBOARD_LINK,
    buttonDisabled: false,
  },
  {
    text: 'Mortgage Broker',
    textStrong: 'Funding a bright future starts here.',
    textDesc: <>Save on your mortgage repayments.</>,
    onClick: () =>
      window.open('https://get.snug.com/rentvest/findex/', '_blank'),
    image: findex,
    buttonText: 'Find out more',
    buttonGTMClassName: GTM_FINDEX_DASHBOARD_LINK,
    buttonDisabled: false,
  },
]

function RenterInvestmentDashboard() {
  return (
    <Box>
      <div className="renter-welcome">
        <h3 className="pb10">Own your future, invest today.</h3>
        <p>Build your wealth by investing in property today.</p>
      </div>
      <div className="two-col-box-flex-row sm64 mt50">
        <div className="col-first">
          <div className="sm-property-dashboard">
            <div className="sm-property-dashboard-content">
              <ul>
                {investDashboardTileProps.map((tileProps) => (
                  <InvestDashboardTile
                    text={tileProps.text}
                    onClick={tileProps.onClick}
                    image={tileProps.image}
                    textStrong={tileProps.textStrong}
                    textDesc={tileProps.textDesc}
                    buttonText={tileProps.buttonText}
                    buttonGTMClassName={tileProps.buttonGTMClassName}
                    buttonDisabled={tileProps.buttonDisabled}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}
export default RenterInvestmentDashboard
